import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';
import {Category, Pageable, Question} from 'src/app/models';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FaqService {
    url = 'api/v1/faq';

    constructor(public http: HttpClient) {
    }

    getCategories(): Observable<Category[]> {
        return this.http.get<Category[]>(`${this.url}/categories`)
            .pipe(map(categoryPage => categoryPage['content']));
    }

    createCategory(category: any): any {
        return this.http.post(`${this.url}/categories`, category);
    }

    deleteCategory(id: number): any {
        return this.http.delete(`${this.url}/categories/${id}`);
    }

    updateCategory(category: any): any {
        return this.http.put(`${this.url}/categories/${category.id}`, category);
    }

    getQuestions(id: number): Observable<Question[]> {
        return this.http.get<Question[]>(`${this.url}/questions/category/${id}`)
            .pipe(map(questionPage => questionPage['content']));
    }

    getQuestion(id: number): Observable<Question[]> {
        return this.http.get<Question[]>(`${this.url}/questions/${id}`);
    }

    searchQuestions(term: string, categoryId?: number): Observable<Question[]> {
        return this.http.get<Question[]>(`${this.url}/questions/search?identifier=${term}` + (categoryId !== null ? `&categoryId=${categoryId}` : ""))
            .pipe(map(questionPage => questionPage['content']));
    }

    searchQuestionsPage(term: string, page: number, categoryId?: number): Observable<Pageable<Question>> {
        return this.http.get<Pageable<Question>>(`${this.url}/questions/search?identifier=${term}&size=${page}` + (categoryId ? `&categoryId=${categoryId}` : ""));
    }

    createQuestion(question: any): any {
        return this.http.post(`${this.url}/questions`, question);
    }

    deleteQuestion(id: number): any {
        return this.http.delete(`${this.url}/questions/${id}`);
    }

    updateQuestion(question: any): any {
        return this.http.put(`${this.url}/questions/${question.id}`, question);
    }
}


